import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  Injector,
  forwardRef,
  inject,
  input,
  numberAttribute,
} from '@angular/core';
import { NgClass } from '@angular/common';
import {
  AbstractControl,
  ControlValueAccessor,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  NgControl,
  ReactiveFormsModule,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BaseControlValueAccessor } from '../base-control-value-accessor';

@Component({
  selector: 'lib-form-text-area',
  templateUrl: './form-text-area.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, MatInputModule, MatFormFieldModule, NgClass],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormTextAreaComponent),
      multi: true,
    },
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => FormTextAreaComponent), multi: true },
  ],
})
export class FormTextAreaComponent
  extends BaseControlValueAccessor<string>
  implements AfterContentInit, ControlValueAccessor, Validator
{
  private static nextId = 0;
  private injector = inject(Injector);

  readonly inputId = `form-text-area-${FormTextAreaComponent.nextId++}`;
  label = input<string>('');
  hideRequiredMarker = input<boolean>(false);
  rows = input<number>(3);
  placeholder = input<string>('');
  maxlength = input<number | null, unknown>(null, { transform: numberAttribute });
  readonly = input<boolean>(false);

  ngAfterContentInit(): void {
    const ngControl = this.injector.get(NgControl, null);
    this.control = (ngControl?.control as FormControl) ?? new FormControl();
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return control.valid ? null : control.errors;
  }

  protected override getLabel(): string {
    return this.label() || '';
  }
}
